import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../common/constants/defaultStaticUrls';
import { useEffect } from 'react';

export const NotFoundPage = (): null => {
  const navigate = useNavigate();
  useEffect(() => navigate(ROUTES.HOME));

  return null;
};
